module.exports = __webpack_public_path__ + "img/collaborate_1.6865c68d.jpg";